/* tslint:disable */
 
import { AccessRightDto } from './access-right-dto';
import { DataEntryFullTextSearch } from './data-entry-full-text-search';
import { ReferenceProperty } from './reference-property';

/**
 * (tsType: Omit<UserDtoWithRelations, 'creationInfo' | 'updateInfo' | 'specificationVersion' | 'stateHistory'>, schemaOptions: { includeRelations: true, exclude: [ 'creationInfo', 'updateInfo', 'specificationVersion', 'stateHistory' ], title: 'permissionList' })
 */
export class PermissionList {
  basedOn?: Array<ReferenceProperty>;
  dataEntity: string;
  entityVersion?: number;
  entryType?: 0 | 1;
  id?: string;

  /**
   * The reason why the entry is invalid
   */
  invalidReason?: 0 | 1;
  isImplicit?: boolean;

  /**
   * Whether the entry is invalid or not
   */
  isInvalid: boolean;
  lifeCycleStatus?: -1 | 0 | 1;
  permission: Array<AccessRightDto>;
  searchIndex?: DataEntryFullTextSearch;
  state: 0 | 1 | 2;
  store?: ReferenceProperty;
  value: any;
  virtual?: boolean;
}
